import * as News from 'AgentNewsAdministration/models/News';
import {Async, fromResult, Loaded, Loading, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {flow} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import {createAction} from 'Shared/utilities/actionCreator';

export enum AgentNewsEntryActionType {
  CHANGE_NEWS_ENTRY = 'newsEntry/CHANGE_NEWS_ENTRY',
  SAVE_NEWS_ENTRY = 'newsEntry/SAVE_NEWS_ENTRY',
  GET_NEWS_ENTRY = 'newsEntry/GET_NEWS_ENTRY',
  LOAD_NEWS_ENTRY = 'newsEntry/LOAD_NEWS_ENTRY',
  CLEAR = 'newsEntry/CLEAR',
}

export const changeTitle = (title: string) =>
  createAction(AgentNewsEntryActionType.CHANGE_NEWS_ENTRY, {changeNewsEntry: News.changeTitle(title)});
export const changeDescription = (description: string) =>
  createAction(AgentNewsEntryActionType.CHANGE_NEWS_ENTRY, {changeNewsEntry: News.changeDescription(description)});
export const saveNewsEntry = (newsEntry: News.ValidNewsEntry) =>
  createAction(AgentNewsEntryActionType.SAVE_NEWS_ENTRY, {newsEntry});
export const showError = (errorMessage: string, newsEntry: News.ValidNewsEntry) =>
  createAction(AgentNewsEntryActionType.CHANGE_NEWS_ENTRY, {
    changeNewsEntry: (existingNewsEntry: News.NewsEntry) => News.NewsEntryWithError.create(errorMessage, newsEntry),
  });
export const getNewsEntry = (id: string) => createAction(AgentNewsEntryActionType.GET_NEWS_ENTRY, {id});
export const loadNewsEntry = (newsEntry: News.NewsEntry) =>
  createAction(AgentNewsEntryActionType.LOAD_NEWS_ENTRY, {newsEntry});
export const clear = () => createAction(AgentNewsEntryActionType.CLEAR);

export type AgentNewsEntryState = Async<News.NewsEntry>;

export const DEFAULT_STATE = new Loaded(News.EmptyNewsItem);

type AgentNewsEntryAction =
  | ReturnType<typeof clear>
  | ReturnType<typeof getNewsEntry>
  | ReturnType<typeof loadNewsEntry>
  | ReturnType<typeof showError>
  | ReturnType<typeof saveNewsEntry>
  | ReturnType<typeof changeTitle>
  | ReturnType<typeof changeDescription>;

export default (state: AgentNewsEntryState = DEFAULT_STATE, action: AgentNewsEntryAction): AgentNewsEntryState => {
  switch (action.type) {
    case AgentNewsEntryActionType.LOAD_NEWS_ENTRY:
      return fromResult(action.payload.newsEntry);
    case AgentNewsEntryActionType.GET_NEWS_ENTRY:
    case AgentNewsEntryActionType.SAVE_NEWS_ENTRY:
      return new Loading();
    case AgentNewsEntryActionType.CHANGE_NEWS_ENTRY:
      return pipe(
        state,
        toEither,
        E.fold(() => state, flow(action.payload.changeNewsEntry, fromResult))
      );
    case AgentNewsEntryActionType.CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
